import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogHeader,
} from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Info } from "lucide-react";
import { usePolizasCacheStore } from "../lib/stores/polizas-cache-store";
import { formatRut } from "../../lib/rut-validator";

type PropsPolizas = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

const separarRutYDv = (
  rutCompleto: string
): { rut: number | null; dv: string | null } => {
  if (!rutCompleto.trim()) {
    return { rut: null, dv: null };
  }

  // Limpiar puntos y guiones
  const rutLimpio = rutCompleto
    .replace(/\./g, "")
    .replace(/-/g, "")
    .toUpperCase();

  // Separar número y DV
  const numero = rutLimpio.slice(0, -1);
  const dv = rutLimpio.slice(-1);

  // Validar que el DV sea un dígito o K
  if (!/^[0-9K]$/.test(dv)) {
    return { rut: null, dv: null };
  }

  // Validar que el número sea numérico
  const rutNumero = parseInt(numero, 10);
  if (isNaN(rutNumero)) {
    return { rut: null, dv: null };
  }

  return { rut: rutNumero, dv };
};

export default function PolizasForm({
  open,
  onOpenChange,
}: //   numeroPoliza,
//   editMode,
PropsPolizas) {
  const [RutEmpresa, setRutEmpresa] = useState("");
  const [poliza, setPoliza] = useState("");
  const [modalError, setModalError] = useState("");
  const { addPoliza } = usePolizasCacheStore();
  const navigate = useNavigate();
  const baseUrl = import.meta.env.VITE_BASE_URL;

  const handleRutChange = (value: string) => {
    const formatted = formatRut(value);

    setRutEmpresa(formatted);
  };

  const handleContinuarPoliza = () => {
    if (!poliza.trim()) {
      setModalError("Debes ingresar el N° de Póliza");
      return;
    }

    let rutEmpresaNum: number | undefined = undefined;
    let dvEmpresa: string | undefined = undefined;

    if (RutEmpresa.trim()) {
      const { rut, dv } = separarRutYDv(RutEmpresa);

      if (!rut || !dv) {
        setModalError("El RUT ingresado no es válido. Formato: 12345678-9");
        return;
      }

      rutEmpresaNum = rut;
      dvEmpresa = dv;
    }

    const nuevaPoliza = {
      id: Date.now(),
      numeroPoliza: parseInt(poliza),
      codigoPlan: undefined,
      nombrePlan: undefined,
      RutContratante: rutEmpresaNum || 322323,
      rutFormatedContratante: RutEmpresa,
      beneficiarios: [],
    };

    try {
      // Guardar en el store de Zustand
      addPoliza(nuevaPoliza);
      //   setCurrentPoliza(nuevaPoliza);

      // Limpiar errores
      setModalError("");

      // Cerrar el modal
      if (onOpenChange) {
        onOpenChange(false);
      }

      navigate(`${baseUrl}/polizas`, { replace: true });
    } catch (error) {
      setModalError("Error al guardar la póliza. Intenta nuevamente.");
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2  text-[var(--color-z-blue)]">
            <Info className="h-5 w-5 text-[var(--color-z-blue)]" />
            Registrar Póliza
          </DialogTitle>
          <DialogDescription>
            Tienes que ingresar un número de póliza para continuar
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <Label className=" text-[var(--color-z-blue)]">
              RUT Empresa (opcional)
            </Label>
            <Input
              value={RutEmpresa}
              onChange={(e) => handleRutChange(e.target.value)}
            />
          </div>

          <div>
            <Label className=" text-[var(--color-z-blue)]">N° Póliza</Label>
            <Input
              value={poliza}
              onChange={(e) => setPoliza(e.target.value)}
              required
            />
          </div>

          {modalError && <p className="text-sm text-red-600">{modalError}</p>}

          <Button
            onClick={handleContinuarPoliza}
            className="bg-[var(--color-z-blue)]"
          >
            Continuar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
